export default __webpack_public_path__ + "a31e8de9d7f438c7d0680ac0fe023788.png";